var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Button as ButtonBase } from '@realm-kf/halcyon-components-react';
import styles from './button.css';
var getCustomClasses = function (variant) {
    if (variant == 'tertiary-dark') {
        return styles.SecondaryButton;
    }
    return styles.PrimaryButton;
};
var getButtonClasses = function (_a) {
    var _b;
    var variant = _a.variant, classes = _a.classes, disabled = _a.disabled;
    return classnames(styles.Button, getCustomClasses(variant), (_b = {}, _b[styles.DisabledButton] = disabled, _b), classes);
};
var Button = function (props) {
    var children = props.children, variant = props.variant, disabled = props.disabled, dataTestId = props.dataTestId, other = __rest(props, ["children", "variant", "disabled", "dataTestId"]);
    return (React.createElement(ButtonBase, __assign({ "data-testid": dataTestId, classes: getButtonClasses(props), variant: variant, disabled: disabled }, other), children));
};
export { Button };
